import type { FC } from 'react'
import { Chip as MuiChip, type ChipProps as MuiChipProps } from '@mui/material'

export type ChipProps = Omit<MuiChipProps, 'avatar' | 'color' | 'variant'> & Readonly<{ variant: NonNullable<MuiChipProps['variant']> }>

/**
 * `Chip` is just a wrapper for MuiChip that:
 * - deprecates usage of `avatar` (use `icon` instead)
 * - deprecates usage of `color`
 * - makes `variant` prop mandatory
 */
export const Chip: FC<ChipProps> = MuiChip
